import React from 'react';
import ReactDOM from 'react-dom';
import Axios from 'axios';
import Alertify from 'alertifyjs';
import FacturaInterfaz from './factura_interfaz';
import cargar_doctores from './funciones_extras';
import VerFacturas from './ver_facturas';
import PerfilPaciente from './perfil_paciente';
import alertify from 'alertifyjs';
import { Link,Redirect } from 'react-router-dom';


class  AgregarFactura extends React.Component{

    constructor(props){
        super(props);
        this.state= {
            procedimientos:[],
            total:0,
            lista_procedimiento:[],
            doctores:[],
            factura:'',
            boton_estado:true,
            paciente: { nombre: '', apellido: '' },
            presupuestosPaciente: [],
            filtroPresupuesto: '',
            desglosePresupuestoAbierto: false
        };
        this.removeTodo = this.removeTodo.bind(this);

    }

    // Función para reproducir sonido al agregar procedimiento
    reproducirSonidoAgregar = () => {
        try {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            
            oscillator.frequency.value = 800; // Frecuencia más aguda
            oscillator.type = 'sine';
            
            gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);
            
            oscillator.start(audioContext.currentTime);
            oscillator.stop(audioContext.currentTime + 0.2);
        } catch (error) {
            console.log("Error al reproducir sonido:", error);
        }
    }

    // Función para reproducir sonido al guardar/generar
    reproducirSonidoGuardar = () => {
        try {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            
            // Sonido más grave y largo
            oscillator.frequency.value = 600;
            oscillator.type = 'sine';
            
            gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.4);
            
            oscillator.start(audioContext.currentTime);
            oscillator.stop(audioContext.currentTime + 0.4);
        } catch (error) {
            console.log("Error al reproducir sonido:", error);
        }
    }

    removeTodo(name,resta){
        this.setState({
            lista_procedimiento: this.state.lista_procedimiento.filter(el => el !== name),total:this.state.total-resta
        },()=>{
            console.log(this.state.lista_procedimiento);
        });
    }

    actualizarCantidadProcedimiento = (index, nuevaCantidad) => {
        const num = Math.max(1, parseInt(nuevaCantidad, 10) || 1);
        const list = [...this.state.lista_procedimiento];
        const item = list[index];
        if (!item) return;
        const precioUnitario = item.total / (item.cantidad || 1);
        list[index] = { ...item, cantidad: num, total: precioUnitario * num };
        const newTotal = list.reduce((s, p) => s + p.total, 0);
        this.setState({ lista_procedimiento: list, total: newTotal });
    };


    componentDidMount(){
        cargar_doctores.cargar_procedimientos(this);
        cargar_doctores.cargar_doctores(this);
        cargar_doctores.cargar_paciente(this, this.props.match.params.id);
        this.cargarPresupuestosPaciente();
    }

    cargarPresupuestosPaciente = () => {
        const pacienteId = this.props.match.params.id;
        if (!pacienteId) return;
        Axios.get(`${cargar_doctores.url_base}/api/cargar_presupuestos/${pacienteId}`)
            .then((res) => {
                this.setState({ presupuestosPaciente: res.data || [] });
            })
            .catch(() => {
                this.setState({ presupuestosPaciente: [] });
            });
    };

    cargarPresupuestoComoFactura = (idPresupuesto) => {
        Axios.get(`${cargar_doctores.url_base}/api/cargar_presupuesto/${idPresupuesto}`)
            .then((res) => {
                const data = res.data;
                let procedimientos = data.procedimientos || [];
                if (Array.isArray(procedimientos) && procedimientos.length > 0 && Array.isArray(procedimientos[0])) {
                    procedimientos = procedimientos[0];
                }
                const lista = procedimientos.map((p) => ({
                    nombre_procedimiento: p.nombre_procedimiento || p.nombre || 'Procedimiento',
                    total: Number(p.total) || 0,
                    id_procedimiento: p.id_procedimiento || p.id || 0,
                    cantidad: Number(p.cantidad) || 1
                }));
                const total = lista.reduce((sum, p) => sum + (Number(p.total) || 0), 0) || (Number(data.total) || 0);
                this.setState({
                    lista_procedimiento: lista,
                    total: total,
                    boton_estado: false
                });
                if (data.doctor_id && document.getElementById('doctor_i')) {
                    const sel = document.getElementById('doctor_i');
                    if (sel) sel.value = data.doctor_id;
                }
                this.reproducirSonidoAgregar();
                Alertify.success('Presupuesto cargado como factura. Puede editar y generar.');
            })
            .catch((err) => {
                Alertify.error(err.response?.data?.error || 'Error al cargar presupuesto');
            });
    };

    agregarProcedimiento=(id,nombre,precio)=>{



       Alertify.prompt( 'Que cantidad de procedimientos quieres agregar?', 'Digite el numero de procedimientos de este tipo que quiere agregar', '1'
               ,(evt, value)=>{ 
                    
                    this.setState(state=>({
                        lista_procedimiento:state.lista_procedimiento.concat({nombre_procedimiento:nombre,total:precio*value,id_procedimiento:id,cantidad:value})
                    }));
                    this.setState({total:this.state.total+(value*precio)}, () => {
                        // Scroll suave hacia la lista de procedimientos agregados después de un pequeño delay
                        setTimeout(() => {
                            const listaProcedimientos = document.getElementById('lista-procedimientos-agregados');
                            if (listaProcedimientos) {
                                // Hacer scroll suave hacia el card de procedimientos agregados
                                listaProcedimientos.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                // También hacer scroll dentro de la tabla si hay muchos procedimientos
                                const tableBody = listaProcedimientos.querySelector('tbody');
                                if (tableBody && tableBody.lastElementChild) {
                                    setTimeout(() => {
                                        tableBody.lastElementChild.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                                    }, 300);
                                }
                            }
                        }, 150);
                    });
                    // Reproducir sonido al agregar procedimiento
                    this.reproducirSonidoAgregar();
                }
               ,()=> { Alertify.error('Cancel') }).set('type','text');

    }

    generar_factura=()=>{
            //accion a ajecutar cuando se haga click en generar factura
            var id_doctor = document.querySelector("#doctor_i").value;
            const usuarioId = localStorage.getItem("id_usuario");
            if(this.state.boton_estado==false){  
            Axios.post(`${cargar_doctores.url_base}/api/crear_factura`,{
                id_paciente:this.props.match.params.id,
                id_doctor:id_doctor,
                total:this.state.total,
                procedimientos:[this.state.lista_procedimiento],
                usuario_id: usuarioId
            }).then((data)=>{

                    console.log(data.data);
                    this.setState({total:0,lista_procedimiento:[],factura:'ready'});
                    // Reproducir sonido al generar factura
                    this.reproducirSonidoGuardar();
                    Alertify.success("Factura generada correctamente, puede ir al perfil del paciente y verla");
                    // document.getElementById("agregar_paciente").click();
                    //Redireciona a la factura de pacientes cuando se cargue la factura


                }).catch(error=>{
                    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Error al crear factura";
                    Alertify.error(errorMessage);
                    console.error("Error al crear factura:", error.response?.data || error.message);
            });

            this.state.boton_estado=true;
        }else{
        
            alertify.message("ya generaste una factura!!!!");
        }

    }
    
    eliminar_procedimiento=(indice)=>{
                    console.log("intentando eliminar procedimiento ..");
                    this.setState({})
                    
    }

    retroceder=()=>{

        this.setState({factura:'perfil_paciente'});
    }


    select_checked=()=>{

        let doctor_id =  document.getElementById('doctor_i').value;
        if(doctor_id!=="seleccione_doctor"){

            this.setState({boton_estado:false});
            
            
        }else{

            this.setState({boton_estado:true});
        }

    }


    buscar_procedimiento=()=>{ 
            
        var buscar = document.getElementById("buscando").value;
            Axios.get(`${cargar_doctores.url_base}/api/buscar_procedimiento/${buscar}`).then(data=>{

                    this.setState({procedimientos:data.data});

            }).catch(error=>{

                console.log("error");
            })
    }



    render(){
        
         var indice_procedimiento = 0;

         if(this.state.factura=='ready'){

            return <Redirect to={`/ver_facturas/${this.props.match.params.id}`} />;

         }else if(this.state.factura=='perfil_paciente'){

            return <Redirect to={`/perfil_paciente/${this.props.match.params.id}/${this.props.params.id_doc}`}/>
            
         }else{

            
         }


        return (
            <>
                <style>{`
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(10px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes slideUp {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                `}</style>
                <div className="col-12 col-md-10" style={{ 
                    backgroundColor: '#f5f5f7',
                    minHeight: '100vh',
                    padding: '30px',
                    borderRadius: '16px'
                }}>
                    {/* Header principal */}
                    <div className="card border-0 shadow-lg mb-4" style={{ 
                        borderRadius: '16px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        overflow: 'hidden',
                        animation: 'fadeIn 0.5s ease'
                    }}>
                        <div className="card-body text-white p-4">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div className="d-flex align-items-center mb-3 mb-md-0">
                                    <div style={{
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '15px',
                                        background: 'rgba(255,255,255,0.2)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '20px',
                                        fontSize: '28px'
                                    }}>
                                        <i className="fas fa-file-invoice"></i>
                                    </div>
                                    <div>
                                        <h2 className="mb-0" style={{ fontWeight: 700, fontSize: '32px' }}>
                                            Creación de Factura
                                        </h2>
                                        <p className="mb-0" style={{ opacity: 0.9, fontSize: '15px' }}>
                                            {this.state.paciente.nombre && this.state.paciente.apellido 
                                                ? `Factura para: ${this.state.paciente.nombre} ${this.state.paciente.apellido}`
                                                : 'Agregue procedimientos y genere la factura'
                                            }
                                        </p>
                                    </div>
                                </div>
                                <Link to={`/perfil_paciente/${this.props.match.params.id}/${this.props.match.params.id_doc}`}>
                                    <button className="btn" style={{
                                        background: 'rgba(255,255,255,0.2)',
                                        border: '2px solid rgba(255,255,255,0.3)',
                                        color: 'white',
                                        borderRadius: '12px',
                                        padding: '10px 20px',
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        transition: 'all 0.3s ease',
                                        backdropFilter: 'blur(10px)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.background = 'rgba(255,255,255,0.3)';
                                        e.target.style.transform = 'translateY(-2px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.background = 'rgba(255,255,255,0.2)';
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <i className="fas fa-arrow-left me-2"></i>Retroceder
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Cargar desde presupuesto: solo desglosable si el paciente tiene presupuestos */}
                    {this.state.presupuestosPaciente.length > 0 ? (
                        <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                            <div
                                role="button"
                                tabIndex={0}
                                onClick={() => this.setState({ desglosePresupuestoAbierto: !this.state.desglosePresupuestoAbierto })}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.setState({ desglosePresupuestoAbierto: !this.state.desglosePresupuestoAbierto }); } }}
                                className="card-header border-0 d-flex align-items-center justify-content-between"
                                style={{
                                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                    padding: '16px 20px',
                                    cursor: 'pointer'
                                }}
                            >
                                <div>
                                    <h5 className="mb-0" style={{ fontWeight: 700, fontSize: '16px', color: '#495057' }}>
                                        <i className="fas fa-file-invoice-dollar me-2 text-primary"></i>
                                        Cargar desde presupuesto
                                    </h5>
                                    <p className="mb-0 mt-1 small text-muted">
                                        Seleccione un presupuesto para cargar sus procedimientos como factura.
                                        <span className="d-block mt-1 fw-bold text-primary" style={{ fontSize: '13px' }}>
                                            {this.state.presupuestosPaciente.length} presupuesto{this.state.presupuestosPaciente.length !== 1 ? 's' : ''} disponible{this.state.presupuestosPaciente.length !== 1 ? 's' : ''}
                                        </span>
                                    </p>
                                </div>
                                <i className={`fas fa-chevron-${this.state.desglosePresupuestoAbierto ? 'up' : 'down'}`} style={{ fontSize: '18px', color: '#6c757d' }}></i>
                            </div>
                            {this.state.desglosePresupuestoAbierto && (
                                <div className="card-body p-3">
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar presupuesto por nombre..."
                                            value={this.state.filtroPresupuesto}
                                            onChange={(e) => this.setState({ filtroPresupuesto: e.target.value })}
                                            style={{ borderRadius: '10px', padding: '10px 14px' }}
                                        />
                                    </div>
                                    <div className="table-responsive" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                                        <table className="table table-sm table-hover mb-0">
                                            <thead style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                                                <tr>
                                                    <th className="border-0 small font-weight-bold text-muted">Nombre</th>
                                                    <th className="border-0 small font-weight-bold text-muted">Doctor</th>
                                                    <th className="border-0 small font-weight-bold text-muted">Fecha</th>
                                                    <th className="border-0 small font-weight-bold text-muted">Total</th>
                                                    <th className="border-0 small font-weight-bold text-muted text-center">Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.presupuestosPaciente
                                                    .filter((p) => !this.state.filtroPresupuesto || (p.nombre || '').toLowerCase().includes(this.state.filtroPresupuesto.toLowerCase()))
                                                    .map((p) => (
                                                        <tr key={p.id}>
                                                            <td className="align-middle small">{p.nombre || '—'}</td>
                                                            <td className="align-middle small">{p.doctor ? [p.doctor.nombre, p.doctor.apellido].filter(Boolean).join(' ') : '—'}</td>
                                                            <td className="align-middle small">{p.created_at ? new Date(p.created_at).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}</td>
                                                            <td className="align-middle small font-weight-bold text-success">${new Intl.NumberFormat().format((() => { try { if (p.total != null) return p.total; const f = typeof p.factura === 'string' ? JSON.parse(p.factura) : p.factura; return (f && f.total != null) ? f.total : 0; } catch (e) { return 0; } })())}</td>
                                                            <td className="align-middle text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => this.cargarPresupuestoComoFactura(p.id)}
                                                                    style={{ borderRadius: '8px', padding: '6px 12px', fontSize: '12px' }}
                                                                >
                                                                    <i className="fas fa-plus me-1"></i> Cargar como factura
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <p className="mb-3 text-muted small">
                            <i className="fas fa-info-circle me-1"></i> Este paciente no tiene presupuestos para cargar.
                        </p>
                    )}

                    {/* Resumen de factura */}
                    <div className="row g-3 mb-4">
                        <div className="col-12 col-md-8">
                            <div 
                                id="lista-procedimientos-agregados"
                                className="card border-0 shadow-sm mb-4" 
                                style={{ 
                                    borderRadius: '16px',
                                    animation: 'slideUp 0.6s ease',
                                    position: 'sticky',
                                    top: '20px',
                                    zIndex: 10,
                                    maxHeight: 'calc(100vh - 100px)',
                                    overflowY: 'auto'
                                }}
                            >
                                <div className="card-header border-0" style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    borderRadius: '16px 16px 0 0',
                                    padding: '20px',
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 11
                                }}>
                                    <h5 className="mb-0 text-white" style={{ 
                                        fontWeight: 700, 
                                        fontSize: '18px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        <i className="fas fa-list me-2"></i>
                                        Procedimientos Agregados ({this.state.lista_procedimiento.length})
                                    </h5>
                                </div>
                                <div className="card-body p-0" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                                    {this.state.lista_procedimiento.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-hover mb-0" style={{ margin: 0 }}>
                                                <thead style={{
                                                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
                                                }}>
                                                    <tr>
                                                        <th style={{ 
                                                            fontWeight: 600, 
                                                            fontSize: '13px',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            color: '#6c757d',
                                                            padding: '15px 20px',
                                                            border: 'none'
                                                        }}>Procedimiento</th>
                                                        <th style={{ 
                                                            fontWeight: 600, 
                                                            fontSize: '13px',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            color: '#6c757d',
                                                            padding: '15px 20px',
                                                            border: 'none'
                                                        }}>Cantidad</th>
                                                        <th style={{ 
                                                            fontWeight: 600, 
                                                            fontSize: '13px',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            color: '#6c757d',
                                                            padding: '15px 20px',
                                                            border: 'none'
                                                        }}>Monto</th>
                                                        <th style={{ 
                                                            fontWeight: 600, 
                                                            fontSize: '13px',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            color: '#6c757d',
                                                            padding: '15px 20px',
                                                            border: 'none',
                                                            textAlign: 'center'
                                                        }}>Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.lista_procedimiento.map((data, index) => (
                                                        <tr key={index} style={{
                                                            transition: 'all 0.2s ease',
                                                            borderBottom: '1px solid #f0f0f0'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.backgroundColor = 'transparent';
                                                        }}>
                                                            <td style={{ padding: '15px 20px', fontWeight: 500, color: '#2d2d2f' }}>
                                                                {data.nombre_procedimiento}
                                                            </td>
                                                            <td style={{ padding: '15px 20px', color: '#6c757d' }}>
                                                                <input
                                                                    type="number"
                                                                    min={1}
                                                                    value={data.cantidad}
                                                                    onChange={(e) => this.actualizarCantidadProcedimiento(index, e.target.value)}
                                                                    style={{
                                                                        width: '70px',
                                                                        padding: '6px 10px',
                                                                        borderRadius: '8px',
                                                                        border: '2px solid #e0e0e0',
                                                                        fontSize: '14px',
                                                                        fontWeight: 600,
                                                                        textAlign: 'center'
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={{ padding: '15px 20px', fontWeight: 600, color: '#28a745', fontSize: '16px' }}>
                                                                ${new Intl.NumberFormat().format(data.total)}
                                                            </td>
                                                            <td style={{ padding: '15px 20px', textAlign: 'center' }}>
                                                                <button 
                                                                    className="btn"
                                                                    onClick={() => this.removeTodo(data, data.total)}
                                                                    style={{
                                                                        background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '8px',
                                                                        padding: '6px 12px',
                                                                        fontSize: '13px',
                                                                        fontWeight: 600,
                                                                        transition: 'all 0.2s ease',
                                                                        minWidth: '80px'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.transform = 'translateY(-2px)';
                                                                        e.target.style.boxShadow = '0 4px 12px rgba(220, 53, 69, 0.4)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.transform = 'translateY(0)';
                                                                        e.target.style.boxShadow = 'none';
                                                                    }}
                                                                >
                                                                    <i className="fas fa-trash me-1"></i>Eliminar
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="text-center p-5" style={{ color: '#6c757d' }}>
                                            <i className="fas fa-inbox" style={{ fontSize: '48px', marginBottom: '15px', opacity: 0.5 }}></i>
                                            <p style={{ fontSize: '16px', margin: 0 }}>No hay procedimientos agregados</p>
                                            <p style={{ fontSize: '14px', opacity: 0.7 }}>Busque y agregue procedimientos a continuación</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Panel lateral - Total y Doctor */}
                        <div className="col-12 col-md-4">
                            <div className="card border-0 shadow-sm mb-4" style={{ 
                                borderRadius: '16px',
                                background: 'linear-gradient(135deg, #2d2d2f 0%, #1c1c1e 100%)',
                                animation: 'slideUp 0.7s ease'
                            }}>
                                <div className="card-body text-white p-4">
                                    <h5 className="mb-3" style={{ 
                                        fontWeight: 600, 
                                        fontSize: '16px',
                                        opacity: 0.9,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        <i className="fas fa-calculator me-2"></i>
                                        Monto Total
                                    </h5>
                                    <div style={{
                                        fontSize: '42px',
                                        fontWeight: 700,
                                        marginBottom: '25px',
                                        textAlign: 'center',
                                        padding: '20px',
                                        background: 'rgba(255,255,255,0.1)',
                                        borderRadius: '12px',
                                        backdropFilter: 'blur(10px)'
                                    }}>
                                        ${new Intl.NumberFormat().format(this.state.total)}
                                    </div>

                                    <div className="mb-3">
                                        <label style={{ 
                                            fontSize: '14px', 
                                            fontWeight: 600,
                                            marginBottom: '10px',
                                            display: 'block',
                                            opacity: 0.9,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>
                                            <i className="fas fa-user-md me-2"></i>
                                            Seleccione el Doctor
                                        </label>
                                        <select 
                                            className="form-control" 
                                            style={{
                                                borderRadius: '12px',
                                                border: '2px solid rgba(255,255,255,0.2)',
                                                padding: '14px 16px',
                                                fontSize: '15px',
                                                minHeight: '50px',
                                                height: 'auto',
                                                lineHeight: '1.5',
                                                transition: 'all 0.2s ease',
                                                appearance: 'none',
                                                background: 'rgba(255,255,255,0.1)',
                                                color: 'white',
                                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='white' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'right 16px center',
                                                paddingRight: '40px',
                                                whiteSpace: 'normal',
                                                wordWrap: 'break-word'
                                            }}
                                            id="doctor_i" 
                                            onChange={this.select_checked}
                                            onFocus={(e) => {
                                                e.target.style.borderColor = 'rgba(255,255,255,0.5)';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(255,255,255,0.1)';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                                                e.target.style.boxShadow = 'none';
                                            }}
                                        >
                                            <option value="seleccione_doctor" style={{ color: '#333' }}>Seleccione un doctor</option>
                                            {this.state.doctores.map(data => (
                                                <option key={data.id} value={data.id} style={{ color: '#333' }}>
                                                    {data.nombre} {data.apellido}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <button 
                                        className="btn w-100"
                                        onClick={this.generar_factura} 
                                        disabled={this.state.boton_estado}
                                        style={{
                                            background: this.state.boton_estado 
                                                ? 'rgba(255,255,255,0.1)' 
                                                : 'linear-gradient(135deg, #28a745 0%, #218838 100%)',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '12px',
                                            padding: '14px 20px',
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            transition: 'all 0.3s ease',
                                            cursor: this.state.boton_estado ? 'not-allowed' : 'pointer',
                                            opacity: this.state.boton_estado ? 0.5 : 1
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!this.state.boton_estado) {
                                                e.target.style.transform = 'translateY(-2px)';
                                                e.target.style.boxShadow = '0 4px 12px rgba(40, 167, 69, 0.4)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!this.state.boton_estado) {
                                                e.target.style.transform = 'translateY(0)';
                                                e.target.style.boxShadow = 'none';
                                            }
                                        }}
                                    >
                                        <i className="fas fa-file-invoice me-2"></i>
                                        Generar Factura
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Búsqueda de procedimientos */}
                    <div className="card border-0 shadow-sm mb-4" style={{ 
                        borderRadius: '16px',
                        animation: 'slideUp 0.8s ease'
                    }}>
                        <div className="card-body p-4">
                            <div className="input-group">
                                <span className="input-group-text" style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '12px 0 0 12px',
                                    padding: '14px 20px',
                                    fontSize: '18px'
                                }}>
                                    <i className="fas fa-search"></i>
                                </span>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="buscando" 
                                    onKeyUp={this.buscar_procedimiento} 
                                    placeholder="Escriba el procedimiento que desea buscar..."
                                    style={{
                                        borderRadius: '0 12px 12px 0',
                                        border: '2px solid #e0e0e0',
                                        borderLeft: 'none',
                                        padding: '14px 16px',
                                        fontSize: '15px',
                                        minHeight: '50px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#667eea';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e0e0e0';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Lista de procedimientos */}
                    <div className="card border-0 shadow-sm" style={{ 
                        borderRadius: '16px',
                        animation: 'slideUp 0.9s ease'
                    }}>
                        <div className="card-header border-0" style={{
                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            borderRadius: '16px 16px 0 0',
                            padding: '20px'
                        }}>
                            <h5 className="mb-0" style={{ 
                                fontWeight: 600, 
                                fontSize: '18px',
                                color: '#2d2d2f',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                            }}>
                                <i className="fas fa-procedures me-2" style={{ color: '#667eea' }}></i>
                                Procedimientos Disponibles
                            </h5>
                        </div>
                        <div className="card-body p-3">
                            <div className="row g-2">
                                {this.state.procedimientos.length > 0 ? (
                                    this.state.procedimientos.map((data, index) => (
                                        <div key={index} className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <div className="card border-0 shadow-sm h-100" style={{
                                                borderRadius: '12px',
                                                transition: 'all 0.3s ease',
                                                border: '2px solid #e0e0e0',
                                                cursor: 'pointer'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-3px)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.2)';
                                                e.currentTarget.style.borderColor = '#667eea';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.08)';
                                                e.currentTarget.style.borderColor = '#e0e0e0';
                                            }}>
                                                <div className="card-body p-3">
                                                    <h6 style={{ 
                                                        fontWeight: 600, 
                                                        fontSize: '13px',
                                                        color: '#2d2d2f',
                                                        marginBottom: '10px',
                                                        minHeight: '36px',
                                                        lineHeight: '1.4',
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}>
                                                        {data.nombre}
                                                    </h6>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span style={{ 
                                                            fontSize: '11px', 
                                                            color: '#6c757d',
                                                            fontWeight: 600
                                                        }}>
                                                            Precio:
                                                        </span>
                                                        <span style={{ 
                                                            fontSize: '16px', 
                                                            fontWeight: 700,
                                                            color: '#28a745'
                                                        }}>
                                                            ${new Intl.NumberFormat().format(data.precio)}
                                                        </span>
                                                    </div>
                                                    <button 
                                                        className="btn w-100"
                                                        onClick={() => this.agregarProcedimiento(data.id, data.nombre, data.precio)}
                                                        style={{
                                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '8px',
                                                            padding: '8px 12px',
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.transform = 'translateY(-2px)';
                                                            e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                    >
                                                        <i className="fas fa-plus me-1"></i>Agregar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center p-5" style={{ color: '#6c757d' }}>
                                        <i className="fas fa-search" style={{ fontSize: '48px', marginBottom: '15px', opacity: 0.5 }}></i>
                                        <p style={{ fontSize: '16px', margin: 0 }}>Busque un procedimiento para comenzar</p>
                                        <p style={{ fontSize: '14px', opacity: 0.7 }}>Escriba en el campo de búsqueda arriba</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }


}

export default AgregarFactura;